import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import projectService from '../../services/project';
import type { Action } from '../../state/actions';
import { projectContextSelector } from '../../state/context/selectors';
import {
	FETCH_PROJECT_DETAILS,
	fetchProjectDetailsSuccess,
	fetchProjectDetailsFail,
} from '../../state/entities/actions';
import type { AppState } from '../../state/types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>, store: MiddlewareAPI<AppState>) =>
	action$.ofType(FETCH_PROJECT_DETAILS).mergeMap(() =>
		Observable.fromPromise(
			projectService.getProjectDetails(projectContextSelector(store.getState())),
		)
			.map(fetchProjectDetailsSuccess)
			.catch((error) => Observable.of(fetchProjectDetailsFail(error))),
	);
